import axios from "axios";

const api = axios.create({
    baseURL: `http://localhost:${process.env?.PORT || 3000}`
})

api.interceptors.request.use(config => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config;
})

api.interceptors.response.use(

    response => response,

    async error => {

        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry
        ) {

            originalRequest._retry = true;

            try {

                const refresh = await axios.post(
                    "http://localhost:1000/refresh",
                    {
                        refreshToken: localStorage.getItem("refresh_token")
                    }
                );

                localStorage.setItem(
                    "access_token",
                    refresh.data.accessToken
                );

                localStorage.setItem(
                    "refresh_token",
                    refresh.data.refreshToken
                );

                originalRequest.headers.Authorization =
                    `Bearer ${refresh.data.accessToken}`;

                return api(originalRequest);

            } catch {

                localStorage.removeItem("access_token");
                localStorage.removeItem("refresh_token");

                window.location.href = "/SignUp";
            }

        }

        return Promise.reject(error);

    }

);


export default api;